import type { Environment } from '../types/';

// Injected at build via vite.config `define`.
declare const __APP_ENV__: Environment | undefined;

interface AppEnvironmentSource {
  VERCEL_ENV?: string;
  VERCEL_GIT_COMMIT_REF?: string;
}

/**
 * Not huge fan of this, but for now we rely on Vercel environment variables
 * to determine the current environment, we could adjust the logic here in case of needed.
 */
export const getAppEnvironment = (env: AppEnvironmentSource): Environment => {
  if (env.VERCEL_ENV === 'production') {
    return 'production';
  }

  if (env.VERCEL_ENV === 'preview') {
    const branch = env.VERCEL_GIT_COMMIT_REF || '';

    if (branch === 'qa') {
      return 'qa';
    }

    return `preview-${branch
      .replace(/[^a-zA-Z0-9-]/g, '-') // Replace unwanted chars with hyphen
      .replace(/-+/g, '-') // Collapse consecutive hyphens
      .replace(/^-+|-+$/g, '')}`; // Trim leading/trailing hyphens
  }

  return 'local';
};

/**
 * Runtime environment. Reads the value baked at build time into `__APP_ENV__`
 * — `getAppEnvironment` must NOT be called at runtime because `VERCEL_ENV` is
 * not exposed to the client (no `VITE_` prefix). Falls back to `'local'` where
 * the build didn't define it (Storybook).
 */
export const getCurrentEnvironment = (): Environment =>
  typeof __APP_ENV__ !== 'undefined' ? __APP_ENV__ : 'local';
